export const POST_IMPORT = 'POST_IMPORT';
export const POST_IMPORT_START = `${POST_IMPORT}_START`;
export const POST_IMPORT_SUCCESS = `${POST_IMPORT}_SUCCESS`;
export const POST_IMPORT_FAIL = `${POST_IMPORT}_FAIL`;

export function postImport(formData) {
  return dispatch => {
    dispatch({ type: POST_IMPORT_START });

    return fetch('/webapi/xm/1/uploads/users-v1', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
      method: 'POST',
      body: formData,
    })
      .then(resp => {
        if (resp && !resp.ok) {
          return Promise.reject(resp);
        }

        dispatch({ type: POST_IMPORT_SUCCESS });
        return true;
      })
      .catch(response => {
        dispatch({ type: POST_IMPORT_FAIL, response });

        throw new Error(response.statusText);
      });
  };
}

export const CLEAR_UPLOAD_ERROR_STATE = 'CLEAR_UPLOAD_ERROR_STATE';

export function clearUploadErrorState() {
  return dispatch => {
    dispatch({ type: CLEAR_UPLOAD_ERROR_STATE });
  };
}
